/*
* App UserBox
* */

import React from 'react';
import ReactDOM from 'react-dom';
import { get, set } from './components/Storage';
import { getSetting } from './components/UserSettings';

// Init Configuration
import './components/Init';
import App from './components/App';
import axios from 'axios';

var AppSettings = get();

import injectTapEventPlugin from "react-tap-event-plugin";
// Aggiungere il try catch per gestire injectTapEventPlugin multipli
try{
    injectTapEventPlugin();
   }
catch(e){}

if (AppSettings.usersettings && AppSettings.isauthenticated) {
    var url = AppSettings['env'].urlUserBoxGetUserSettings;
    axios.get(url)
        .then(({ data, status, statusText }) => {
            if (data.errors.length == 0) {
                try {
                    var userSettings = JSON.parse(data.value);
                    if (userSettings.preferredDeposit == undefined) {
                        userSettings.preferredDeposit = [];
                    }
                    if (userSettings.preferredWithdrawal == undefined) {
                        userSettings.preferredWithdrawal = [];
                    }

                    if (userSettings.toolbarMode == undefined) {
                        userSettings.toolbarMode = "full";
                    }
                    
                    if (AppSettings.device == "mobile") {
                        userSettings.toolbarMode = "compact";
                    }
                    /*
                    else{
                        userSettings.toolbarMode = "full";
                    }*/

                    AppSettings['userSettings'] = userSettings;

                    set(AppSettings);
                }
                catch (e) {
                    console.log("Error get UserSettings");
                }
            }
            const UserBoxAppComponent = ReactDOM.render(<App ref={(UserBoxAppComponent) => {window.UserBoxAppComponent = UserBoxAppComponent}} />, document.getElementById(AppSettings.userbox));
        })
        .catch(() => {
            const UserBoxAppComponent = ReactDOM.render(<App ref={(UserBoxAppComponent) => {window.UserBoxAppComponent = UserBoxAppComponent}} />, document.getElementById(AppSettings.userbox));
        });
}
else {
    const UserBoxAppComponent = ReactDOM.render(<App ref={(UserBoxAppComponent) => {window.UserBoxAppComponent = UserBoxAppComponent}} />, document.getElementById(AppSettings.userbox));
}